/**
 * Indica se o report-link está ativo para exibição (sidebar / viewer).
 * @param {Object} reportLink
 * @returns {boolean}
 */
export function isReportLinkActive(reportLink) {
  return reportLink?.isActive === true;
}
